import { useAtom } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useSurveyQueryFlattenCustomerAttributes } from '~/hooks/useSurveyQuery'

import { columnCustomerAttributeIdsAtom, sortValueAtom } from '../atoms'

export const AllColumnCustomerAttributeGroupsSelectButton = () => {
  const { t } = useTranslation()
  const [columnCustomerAttributeIds, setColumnCustomerAttributeIds] = useAtom(
    columnCustomerAttributeIdsAtom,
  )
  const allCustomerAttributes = useSurveyQueryFlattenCustomerAttributes()
  const allCustomerAttributeIds = React.useMemo(
    () => allCustomerAttributes.map(R.prop('id')),
    [allCustomerAttributes],
  )
  const resetSortValue = useResetAtom(sortValueAtom)
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    if (columnCustomerAttributeIds.length !== allCustomerAttributeIds.length) {
      resetSortValue()
      setColumnCustomerAttributeIds(
        R.piped(R.concat(allCustomerAttributeIds), R.unique()),
      )
    }
  }, [
    allCustomerAttributeIds,
    columnCustomerAttributeIds.length,
    resetSortValue,
    setColumnCustomerAttributeIds,
  ])

  return (
    <StyledButton fillMode="flat" onClick={handleClick}>
      {t('select_all')}
    </StyledButton>
  )
}
